import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';
import {downloadFile} from '../../common/util/file';
import {removeOrder} from './utils';

const INITIAL_STATE = {
  'loading': false,
  'downloading': false,
  'orderType': '',
  'status': '',
  'user': '',
  'partCode': '',
  'orderCode': '',
  'list': [],
};

export const dealerOrdersTracking = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.RESTORE_DEALER_ORDERS_TRACKING]: (state, action) => INITIAL_STATE,
    [ActionTypes.EDIT_DEALER_ORDERS_TRACKING_FILTER]: (state, action) => ({
      ...state,
      [action.payload.field]: action.payload.value,
    }),
    [ActionTypes.GET_DEALER_ORDERS_TRACKING_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_DEALER_ORDERS_TRACKING_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.GET_DEALER_ORDERS_TRACKING_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.DOWNLOAD_DEALER_ORDERS_REQUEST]: (state, action) => ({
      ...state,
      'downloading': true,
    }),
    [ActionTypes.DOWNLOAD_DEALER_ORDERS_SUCCESS]: (state, action) => {
      downloadFile(action.response.data);

      return {
        ...state,
        'downloading': false,
      };
    },
    [ActionTypes.DOWNLOAD_DEALER_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'downloading': false,
    }),
    [ActionTypes.DELETE_DEALER_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DELETE_DEALER_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': removeOrder(state.list, action.payload),
    }),
    [ActionTypes.DELETE_DEALER_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
